import styled from 'styled-components';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';

export const StyledExtraContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
`;

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledModelAnchor = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 40px;
  width: 240px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 0.5px solid ${COLOR.indigo[16]};
  cursor: pointer;
  box-sizing: border-box;
`;

export const StyledPopoverList = styled.div`
  padding: 8px;
`;

export const StyledPopoverItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ $active }) =>
    $active ? COLOR.secondary[40] : 'transparent'};
`;

export const StyledPopoverItemText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledItalicTypography = styled(Typography)`
  font-style: italic !important;
`;

export const StyledTipBox = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  background-color: rgba(0, 122, 255, 0.08);
  width: 100%;
  box-sizing: border-box;
`;

export const StyledTipText = styled(Typography)`
  flex: 1 0 0;
`;
